export function LoadingIndicator() {
  return (
    <div
      style={{
        backgroundColor: 'transparent',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        width: '100vw',
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
      >
        <defs>
          <linearGradient
            id="paint0"
            x1="24"
            y1="4"
            x2="24"
            y2="44"
            gradientUnits="userSpaceOnUse"
          >
            <stop
              offset="0"
              stopColor="#0064FF"
            />
            <stop
              offset="1"
              stopColor="#04B0E7"
            />
          </linearGradient>
        </defs>
        <circle
          id="svg-circular"
          cx="24"
          cy="24"
          r="20"
          fill="none"
          stroke="url(#paint0)"
          strokeWidth="5"
          strokeLinecap="round"
          strokeDasharray="80 120"
          strokeDashoffset="0"
        >
          <animate
            attributeName="stroke-dasharray"
            dur="1.5s"
            repeatCount="indefinite"
            keyTimes="0;0.4;1"
            values="1 120; 80 120; 80 120"
            calcMode="spline"
            keySplines="0 0 0 .42; .58 1 1 1"
          />
          <animate
            attributeName="stroke-dashoffset"
            dur="1.5s"
            repeatCount="indefinite"
            keyTimes="0;0.5;1"
            values="0;-35;-124"
            calcMode="spline"
            keySplines="0 0 0 .42; .458 1 1 1"
          />
          <animateTransform
            attributeName="transform"
            type="rotate"
            dur="2s"
            repeatCount="indefinite"
            from="0 24 24"
            to="359 24 24"
          />
        </circle>
      </svg>
    </div>
  );
}
